<div class="modal-body">
	<div class="modal-header">
		<h2 class="modal-title" [innerHtml]="title"></h2>
		<button type="button" class="btn btn-close" aria-label="Cancel" (click)="close()" data-cy="closeModal">
			<i class="fal fa-xmark"></i>
		</button>
	</div>
	@if (formLoaded) {
		<form (ngSubmit)="submit($event)" class="fade-in">
			<div class="modal-body">
				<div class="char-data__group">
					<rl-form-table-row [labelText]="'Notification Name'" [required]="true"
						[class.has-error]="form.controls.label.errors">
						<ng-template rlFormTableControl>
							<rl-text-input [(formControl)]="form.controls.label"
								[dataLabel]="'NotificationNameInput'"></rl-text-input>
						</ng-template>
						@if (form.controls.label.errors && form.controls.label.touched) {
							<ng-template rlFormTableMessage>
								Notification Name is required.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Description'">
						<ng-template rlFormTableControl>
							<rl-text-input [(formControl)]="form.controls.description"
								[dataLabel]="'DescriptionInput'"></rl-text-input>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Subject'" [required]="true"
						[class.has-error]="form.controls.subject.errors">
						<ng-template rlFormTableControl>
							<rl-text-input [(formControl)]="form.controls.subject"
								[dataLabel]="'SubjectInput'"></rl-text-input>
						</ng-template>
						@if (form.controls.subject.errors && form.controls.subject.touched) {
							<ng-template rlFormTableMessage>
								Subject is required.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Preview Before Send'">
						<ng-template rlFormTableControl>
							<rl-checkbox-input [label]="!!form.controls.previewIndicator.value ? 'Yes' : ''"
								[formControl]="form.controls.previewIndicator"
								[dataLabel]="'checkboxInputPreviewBeforeSendYes'"
								class="d-block py-1"></rl-checkbox-input>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Add Action Button'">
						<ng-template rlFormTableControl>
							<rl-checkbox-input [label]="!!form.controls.addActionBtn.value ? 'Yes' : ''"
								[formControl]="form.controls.addActionBtn"
								[dataLabel]="'checkboxInputAddActionButtonYes'"
								class="d-block py-1"></rl-checkbox-input>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Trigger SNS/SQS Message'">
						<ng-template rlFormTableControl>
							<rl-checkbox-input [label]="!!form.controls.triggerSNSOrSQS.value ? 'Yes' : ''"
								[formControl]="form.controls.triggerSNSOrSQS" [dataLabel]="'TriggerSnsSqsYes'"
								class="d-inline-block py-1"></rl-checkbox-input>
							@if (!notificationMessagesEnabled) {
								<span class="btn-icon btn-info btn-sm cursor-pointer text-medium"><i
										aria-label="Tooltip" role="button" data-pendo="enable-notification-messages"
										class="fal fa-circle-question"></i></span>
							}
						</ng-template>
					</rl-form-table-row>
				</div>
				<div class="char-data__group">
					<rl-form-table-row [labelText]="'Plain Text'" [required]="true"
						[class.has-error]="form.controls.body.errors">
						<ng-template rlFormTableControl>
							<rl-text-area [(formControl)]="form.controls.body"
								[dataLabel]="'plainTextInput'"></rl-text-area>
						</ng-template>
						@if (form.controls.body.errors && form.controls.body.touched) {
							<ng-template rlFormTableMessage>
								Plain Text is required.
							</ng-template>
						}
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'HTML'">
						<ng-template rlFormTableControl>
							<rl-html-editor [formControl]="form.controls.bodyHtml"></rl-html-editor>
						</ng-template>
					</rl-form-table-row>
					<rl-form-table-row [labelText]="'Attachment Types'">
						<ng-template rlFormTableControl>
							<div class="vert-scroll">
								@for (docTemp of allDocTemplatesForCharType; track docTemp) {
									<label class="d-block py-1">
										<input type="checkbox" [id]="docTemp.doc.documentTemplateId"
											[value]="docTemp.doc.documentTemplateId" class="form-check-input me-2"
											[checked]="isDocumentTypeIdChecked(docTemp.doc.documentTemplateId)"
											(change)="onDocumentTypesChange(docTemp.doc.documentTemplateId, $event.target.checked)"
											[attr.data-cy]="'attachmentTypes' + docTemp.doc.templateLabel | trimWhitespace" />
										{{ docTemp.doc.templateLabel }}
									</label>
								}
							</div>
						</ng-template>
					</rl-form-table-row>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-light" (click)="close()" data-cy="cancelButton">Cancel</button>
				<button class="btn btn-success" [disabled]="form.invalid || isSaving" type="submit"
					data-cy="saveButton">Save</button>
			</div>
		</form>
	} @else {
		<div class="modal-body fade-in">
			<rl-form-placeholder [numRows]="5"></rl-form-placeholder>
			<rl-form-placeholder [numRows]="3"></rl-form-placeholder>
		</div>
	}
</div>